import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import LoaderGif from '../../../icons/LoaderGif.gif';
import { Modal } from 'react-bootstrap';
import {
    usersRemoving,
    usersRemovingError,
} from '../../../screens/Admin/selectors';
// import CheckBox from '../../CheckBox';
import { removeUsersRequested } from '../../../screens/Admin/actions';
import { usersAdding, usersAddError } from '../../../screens/Admin/selectors';
import { addUserRequested } from '../../../screens/Admin/actions';

function RemoveUser({ open, user, onCancel, canRemoveOwner }) {
    const dispatch = useDispatch();
    const loading = useSelector((state) => usersRemoving(state));
    const error = useSelector((state) => usersRemovingError(state));
    const loadingAdd = useSelector((state) => usersAdding(state));
    const errorAdd = useSelector((state) => usersAddError(state));
    const [owner, setOwner] = useState(false);
    const [admin, setAdmin] = useState(false);
    const [researcher, setResearcher] = useState(false);
    const { roleIds, isCreator } = user;
    const hasRoles =
        (roleIds &&
            roleIds.length > 0 &&
            roleIds.every((val) => val !== null)) ||
        false;
    const hasAdminRole =
        (roleIds && roleIds.filter((item) => item >= 300).length > 0) || false;
    const hasResearcherRole =
        (roleIds &&
            roleIds.filter((item) => item >= 200 && item < 300).length > 0) ||
        false;

    const [showError, setShowError] = useState(false);

    useEffect(() => {
        if (canRemoveOwner) setOwner(isCreator || false);
        setAdmin(hasAdminRole);
        setResearcher(hasResearcherRole);
    }, [roleIds]);

    useEffect(() => {
        setShowError(false);
    }, [open]);

    const onSave = () => {
        if (hasRoles) {
            // NEXT 4 LINES CAN BE REMOVED
            const roles = [];
            owner && roles.push('OWNER');
            admin && roles.push('PARTNER');
            researcher && roles.push('EXPERT_INDIVIDUAL');
            // REMOVE ABOVE PIECE OF CODE

            dispatch(addUserRequested(user.email, []));
        } else {
            dispatch(removeUsersRequested(user.email));
        }
        setShowError(true);
    };

    useEffect(() => {
        !loading && !loadingAdd && !error && !errorAdd && onCancel();
    }, [loading, loadingAdd]);

    return (
        <div className="admin-delete-modal">
            <Modal
                show={open}
                onHide={onCancel}
                dialogClassName={'admin-delete-modal'}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                centered={true}
                animation={true}
            >
                <div className="row">
                    <div className="col-12">
                        <div className="row title">
                            {hasRoles
                                ? 'Remove From Organization'
                                : 'Cancel Invitation'}
                        </div>
                        <div className="row">
                            {hasRoles
                                ? 'Are you sure you want to remove this person from the organization?'
                                : 'Are you sure you want to cancel this invitation?'}{' '}
                        </div>
                        {hasRoles && (
                            <>
                                <div className="row">
                                    You can add them back later by sending them
                                    a new invitation.
                                </div>
                                {/* <div
                                    className="row justify-content-around"
                                    style={{ padding: '15px 0px' }}
                                >
                                    <CheckBox
                                        label={'Owner'}
                                        id={`user-checkbox-owner`}
                                        onClick={(e) =>
                                            setOwner(e.target.checked)
                                        }
                                        isBold={true}
                                        selected={owner}
                                        disabled={!isCreator || !canRemoveOwner}
                                    />
                                    <CheckBox
                                        label={'Admin'}
                                        id={`user-checkbox-admin`}
                                        onClick={(e) =>
                                            setAdmin(e.target.checked)
                                        }
                                        isBold={true}
                                        selected={admin}
                                        disabled={!hasAdminRole}
                                    />
                                    <CheckBox
                                        label={'Researcher'}
                                        id={`user-checkbox-researcher`}
                                        onClick={(e) =>
                                            setResearcher(e.target.checked)
                                        }
                                        isBold={true}
                                        selected={researcher}
                                        disabled={!hasResearcherRole}
                                    />
                                </div> */}
                                {isCreator && (
                                    <div className="row justify-content-center mt-1">
                                        <small>
                                            There is only one owner per
                                            Organization. Please make someone
                                            else the owner before removing this
                                            user.
                                        </small>
                                    </div>
                                )}
                            </>
                        )}
                        <div className="row">
                            {showError ? error || errorAdd : null}
                        </div>
                        <div className="row">
                            <button
                                className={'btn btn-block delete-admin-button'}
                                type={'button'}
                                onClick={() => onSave()}
                                disabled={isCreator}
                            >
                                {loading || loadingAdd ? (
                                    <img
                                        src={LoaderGif}
                                        width={'25px'}
                                        height={'25px'}
                                    />
                                ) : hasRoles ? (
                                    'Remove'
                                ) : (
                                    'Cancel Invitation'
                                )}
                            </button>
                        </div>

                        <div className="row mt-1">
                            <button
                                className={'btn btn-block delete-button-cancel'}
                                type={'button'}
                                onClick={onCancel}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

RemoveUser.propTypes = {
    open: PropTypes.bool,
    user: PropTypes.object,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    canRemoveOwner: PropTypes.bool,
};

RemoveUser.defaultProps = {
    open: false,
    canRemoveOwner: false,
    user: {},
    onCancel: () => {},
    onConfirm: () => {},
};

export default RemoveUser;
